import { cn } from "@d12labs/utils";
import type { ReactNode } from "react";

/**
 * Sub-header toolbar — search, filter pills, sort, view toggles on the left;
 * result counts / secondary controls on the right. Sits flush under a
 * <PageHeader> with its own hairline divider, so list/grid content below starts
 * clean. Both slots are optional.
 */
export function Toolbar({
	left,
	right,
	className,
}: {
	left?: ReactNode;
	right?: ReactNode;
	className?: string;
}) {
	return (
		<div
			data-slot="toolbar"
			className={cn(
				"flex flex-none items-center justify-between gap-3 border-b border-hairline px-6 py-2.5",
				className,
			)}
		>
			<div className="flex min-w-0 items-center gap-2">{left}</div>
			<div className="flex flex-none items-center gap-2">{right}</div>
		</div>
	);
}
